import { useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconPerson from '@/icons/User.svg';

import { CLIENT_FILTER_OPTIONS } from '../clientFilterOptions';
import { useFilters } from '../FiltersState';

export const FiltersHasClient = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    hasClient: { hasClient, setHasClient },
  } = useFilters();

  const options = CLIENT_FILTER_OPTIONS.map(({ id, label }) => (
    <FilterCheckboxItem
      key={id}
      checked={hasClient.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setHasClient([...hasClient, id]);
        } else {
          setHasClient(hasClient.filter((x) => x !== id));
        }
      }}
    >
      {i18n._(label)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (hasClient.length === 0) {
      return null;
    }

    const count = hasClient.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({
              id: 'settings.organization.entities.agreements.filters.client.label',
              message: 'Client',
            })}
            value={
              hasClient.length === 1
                ? i18n._(CLIENT_FILTER_OPTIONS.find((o) => o.id === hasClient[0])!.label)
                : i18n._({
                    id: 'settings.organization.entities.agreements.filters.client.multiple',
                    message: '{count} options',
                    values: { count },
                  })
            }
            tooltip={
              hasClient.length > 1
                ? hasClient
                    .map((id) => i18n._(CLIENT_FILTER_OPTIONS.find((o) => o.id === id)!.label))
                    .join(', ')
                : undefined
            }
            onClear={() => setHasClient([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconPerson />}
      label={t({
        id: 'settings.organization.entities.agreements.filters.client.label',
        message: 'Client',
      })}
    >
      {options}
    </FiltersSubMenu>
  );
};
